import { render, staticRenderFns } from "./genius_tax.vue?vue&type=template&id=7f82ccd1&scoped=true"
import script from "./genius_tax.vue?vue&type=script&lang=js"
export * from "./genius_tax.vue?vue&type=script&lang=js"
import style0 from "./genius_tax.vue?vue&type=style&index=0&id=7f82ccd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f82ccd1",
  null
  
)

export default component.exports